import { LOTTO_INSTANT } from '@/constants/lotto/instant-lotto'
import store from '@/store';

export const toDate = (date: any): Date => {
    if (typeof date === 'string') return new Date(date.replace(/-/g, '/'));

    if (date instanceof Date) return date;

    return new Date(date);
};

export const isStrEmpty = (str: string): boolean => {
    return !str || str.length === 0 || str === 'undefined';
};

export const isObjEmpty = (obj: any[]): boolean => {
    return !obj || Object.keys(obj).length === 0;
};

export const isArrayEmpty = (arr: any[]): boolean => {
    return !arr || arr.length === 0 || !Array.isArray(arr);
};

export const parseProxyObject = (obj: object) => {
    return JSON.parse(JSON.stringify(obj));
};

export const getStateVueX = () => {
    return JSON.parse(JSON.stringify(store.state));
};

export const getConfigSetup = () => {
    const state = getStateVueX();
    const config = state.config.setup;
    return config;
};

export const getStateStore = () => {
    const state = getStateVueX();
    const config = state;
    return config;
};

export const getFeatures = () => {
    const state = getStateVueX();
    return state.config.features;
};

export const formatDateNoTimeZone = (timestamp: string) => {
    const date = new Date(timestamp);

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    const formattedTimestamp =
        (day < 10 ? '0' : '') +
        day +
        '/' +
        (month < 10 ? '0' : '') +
        month +
        '/' +
        year +
        ' ' +
        (hours < 10 ? '0' : '') +
        hours +
        ':' +
        (minutes < 10 ? '0' : '') +
        minutes +
        ':' +
        (seconds < 10 ? '0' : '') +
        seconds;
    return formattedTimestamp;
};

export const formatDateUTC = (date: string | Date, timeZone = 0, addDays = 0) => {
    const config = getConfigSetup();
    const timeZoneConfig = config?.timeZone || timeZone;
    const dateTime = new Date(date);

    dateTime.setHours(dateTime.getHours() + timeZoneConfig);

    if (addDays) {
        dateTime.setDate(dateTime.getDate() + addDays);
    }

    const options: any = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        timeZone: 'UTC',
    };

    const formattedDateTime = dateTime.toLocaleString('en-US', options);
    const [datePart, timePart] = formattedDateTime.split(', ');
    const [hour, minutes, seconds] = timePart.split(':');
    const [month, day, year] = datePart.split('/');

    const startOfWeek = new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate() - dateTime.getDay() + 1);
    const weekDates: any = [];

    for (let i = 0; i < 7; i++) {
        const weekDate = new Date(startOfWeek.getFullYear(), startOfWeek.getMonth(), startOfWeek.getDate() + i);
        const formattedWeekDate = `${weekDate.getDate().toString().padStart(2, '0')}/${(weekDate.getMonth() + 1).toString().padStart(2, '0')}/${weekDate
            .getFullYear()
            .toString()}`;
        weekDates.push(formattedWeekDate);
    }

    const convertHour = parseInt(hour) >= 12 ? 'pm' : 'am';
    let hour12h = parseInt(hour) % 12;
    hour12h = hour12h === 0 ? 12 : hour12h;
    const result = {
        hour,
        hour12h,
        minutes,
        seconds,
        day,
        month,
        year,
        weekDates,
        convertHour,
    };

    return result;
};

export const formatDate = (
    date: Date,
): {
    minutes: string | number;
    day: string | number;
    month: string | number;
    monthName: string;
    monthFullName: string;
    year: number;
    convertHours: string;
    dayName: string;
    hour24h: string | number;
    seconds: string | number;
} => {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const monthFullNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    let hours = date.getHours();
    let minutes: string | number = date.getMinutes();
    let seconds: string | number = '';
    const dayName = days[date.getDay()];
    const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
    const monthName = monthNames[date.getMonth()];
    const monthFullName = monthFullNames[date.getMonth()];

    const year = date.getFullYear();
    const convertHours = hours >= 12 ? 'pm' : 'am';
    const hour24h = hours < 10 ? '0' + hours : hours;
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;

    seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();

    const param = {
        hours,
        minutes,
        day,
        month,
        monthName,
        monthFullName,
        year,
        convertHours,
        dayName,
        hour24h,
        seconds,
    };

    return param;
};

export const getDrawName = (hour: string) => {
    switch (hour) {
        case '09':
            return 'YIGUI';
        case '10':
            return 'BOGNESSA';
        case '11':
            return 'KHERY';
        case '12':
            return 'MOUNAFANGNI';
        case '13':
            return 'BANNAYA';
        case '14':
            return 'SEWE';
        case '15':
            return 'KHOUNAKELI';
        case '16':
            return 'FERE';
        case '17':
            return 'SABOUI';
        case '18':
            return 'NAFOULI';
        default:
            return '-';
    }
};

export const productRange = (a: number, b: number) => {
    let prd = a,
        i = a;

    while (i++ < b) {
        prd *= i;
    }
    return prd;
};

export const generateCombinations = (n: number, r: number) => {
    if (n == r || r == 0) {
        return 1;
    } else {
        r = r < n - r ? n - r : r;
        return productRange(r + 1, n) / productRange(1, n - r);
    }
};

export const formatPrice = (number: number, decimal = 2) => {
    const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: decimal,
        maximumFractionDigits: decimal,
    });
    return formatter.format(number);
};

export const isCurrentToday = (date: any) => {
    const todayFormat = formatDateUTC(new Date(), 2);
    const dataFormat = formatDateUTC(new Date(date), 2);
    const dataDate = `${dataFormat.day}/${dataFormat.month}/${dataFormat.year}`;
    const today = `${todayFormat.day}/${todayFormat.month}/${todayFormat.year}`;
    return dataDate === today;
};

export const capitalizeFirstLetter = (text: string) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
};

export const getParamQueryTheme = (key: string): string => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const account = params.get(key) || '';
    return account;
};

export const randomColor = (type: string): string => {
    let h, s, l;
    if (type?.includes('nap')) {
        h = '217.5';
        s = '100';
        l = '95.3';
    } else if (type?.includes('perm')) {
        h = '52.9';
        s = '45.9';
        l = '92.7';
    } else if (type?.includes('banker')) {
        h = '344';
        s = '40.5';
        l = '92.7';
    } else {
        h = Math.floor(Math.random() * 360);
        s = Math.floor(Math.random() * 30) + 70;
        l = Math.floor(Math.random() * 30) + 70;
    }
    return `hsl(${h}, ${s}%, ${l}%)`;
};

export const removeDotDash = (current: string) => {
    current = current.replace(/[^0-9, ]/g, '');
    return current;
}

export const generateGroups = (numbers: number[]): string[] => {
    if (numbers.length < 2) {
        return [];
    }

    const banker = numbers[0];
    const pairs: string[] = [];

    for (let i = 1; i < numbers.length; i++) {
        pairs.push(`${banker},${numbers[i]}`);
    }
    return pairs;
}

export const countNumberOfLine = (numbers: number[]): number => {
    const length = generateGroups(numbers).length
    return length === 0 ? 1 : length;
}

export const isEnvironment = () => {
    const environment = process.env.VUE_APP_URL_SETTINGS.includes('dev') ? 'DEV' : 'PRODUCTION';
    return environment;
};

export function splitDataLottoInstant(type: number, data: any, numberLine?: number) {
    const numberShowLimit = numberLine || LOTTO_INSTANT.INSTANT_DETAIL_LIMIT_SHOW_NUMBER_LINE;

    switch (type) {
        case 1:
            return data.slice(0, numberShowLimit);
        case 2:
            console.log('2');

            return data.slice(numberShowLimit, data.length);
        default:
            break;
    }
}
